import { Component, Input, OnInit } from '@angular/core';
import { RequirementDto } from '../../../../../models/job-unit-requirements.model';

import { UntilDestroy } from '@ngneat/until-destroy';
import { JobQualificationsChangeTypeEnum } from '../../../enums/job-qualifications-change-type.enum';
import { JobQualificationChange } from '../../../models/job-qualification-change.model';
import { NgClass, NgFor, NgIf } from '@angular/common';

@UntilDestroy()
@Component({
    selector: 'nova-job-qualifications-skills-change',
    templateUrl: './job-qualifications-skills-change.component.html',
    styleUrls: ['./job-qualifications-skills-change.component.scss'],
    standalone: true,
    imports: [NgIf, NgFor, NgClass]
})
export class JobQualificationsSkillsChangeComponent implements OnInit {
    @Input()
    skills: Array<JobQualificationChange<RequirementDto>>;

    changeType = JobQualificationsChangeTypeEnum;
    processedCategories: Array<{
        category: string;
        skills: Array<JobQualificationChange<RequirementDto>>;
    }> = [];

    ngOnInit(): void {
        if (this.skills) {
            this.processSkills(this.skills);
        }
    }

    processSkills(skills: Array<JobQualificationChange<RequirementDto>>) {
        if (!skills || skills.length === 0) {
            return '-';
        }

        const categories = Array.from(
            new Set(
                skills.map((skill) => {
                    if (skill.changeType === JobQualificationsChangeTypeEnum.Added && !skill.newValue?.isNA) {
                        return skill.newValue?.category;
                    }

                    return skill.originalValue?.category;
                })
            )
        ).filter((c) => c);

        categories.forEach((category) => {
            const skillsByCategory = skills.filter(
                (skill) => skill.originalValue?.category === category || skill.newValue?.category === category
            );
            this.processedCategories.push({ category, skills: skillsByCategory });
        });
    }
}
